// ================================================================
// Phone Node — Configuration Schema
// ================================================================
// منطق شرطی: کی پاسخ می‌ده → اگه منشی → VoIP/Manual → Twilio یا Voice/Image/Both

export const phoneConfigSchema = {
  fields: [
    // ───────────────────────────────────────────
    // 1) چه کسی پاسخ می‌ده؟
    // ───────────────────────────────────────────
    {
      key: 'responder',
      type: 'select',
      labelKey: 'nodes.phone.fields.responder',
      placeholderKey: 'nodes.phone.placeholders.responder',
      required: true,
      options: [
        { value: 'ai',        labelKey: 'nodes.phone.options.ai' },
        { value: 'secretary', labelKey: 'nodes.phone.options.secretary' }
      ]
    },

    // ───────────────────────────────────────────
    // 2) فقط اگه "منشی" انتخاب شد: VoIP یا دستی؟
    // ───────────────────────────────────────────
    {
      key: 'secretaryMode',
      type: 'select',
      labelKey: 'nodes.phone.fields.secretaryMode',
      placeholderKey: 'nodes.phone.placeholders.secretaryMode',
      required: true,
      showIf: { responder: 'secretary' },
      options: [
        { value: 'voip',   labelKey: 'nodes.phone.options.voip' },
        { value: 'manual', labelKey: 'nodes.phone.options.manual' }
      ]
    },

    // ───────────────────────────────────────────
    // 3a) اگه VoIP: نمایش Twilio provider
    // ───────────────────────────────────────────
    {
      key: 'voipProvider',
      type: 'provider',
      labelKey: 'nodes.phone.fields.voipProvider',
      showIf: { responder: 'secretary', secretaryMode: 'voip' },
      provider: {
        id: 'twilio',
        nameKey: 'nodes.phone.providers.twilio',
        icon: 'call',
        color: '#F22F46'
      }
    },

    // ───────────────────────────────────────────
    // 3b) اگه دستی: Voice/Image/Both
    // ───────────────────────────────────────────
    {
      key: 'manualType',
      type: 'select',
      labelKey: 'nodes.phone.fields.manualType',
      placeholderKey: 'nodes.phone.placeholders.manualType',
      required: true,
      showIf: { responder: 'secretary', secretaryMode: 'manual' },
      options: [
        { value: 'voice', labelKey: 'nodes.phone.options.voice' },
        { value: 'image', labelKey: 'nodes.phone.options.image' },
        { value: 'both',  labelKey: 'nodes.phone.options.both' }
      ]
    }
  ]
};
